import { Suspense, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import axios from 'axios';
import Loading from 'components/Common/Loading';
import { useLoadingStore } from 'store/useLoadingStore';
import { GlobalStyles } from 'styles/Global/globalStyles';
import { mindupAdminMobilePaths } from 'constants/path';
import { useSnackBarStore } from 'store/useToastStore';
import SnackBar from 'components/Toast/SnackBar';
import { BackgroundColor } from 'styles/Global/colorSemantic';

export default function MindUpAdminMobileApp() {
    const navigate = useNavigate();
    const location = useLocation();

    const { loading, setLoading } = useLoadingStore();
    const { visible, message, type, hideSnackBar, buttonMessage, onClick } = useSnackBarStore();

    const onSnackbar = localStorage.getItem('snackbar');

    useEffect(() => {
        axios.interceptors.request.use(
            (config) => {
                // setLoading(true);
                return config;
            },
            (error) => {
                // setLoading(false);
                return Promise.reject(error);
            }
        );
        axios.interceptors.response.use(
            (response) => {
                // setLoading(false);
                return response;
            },
            (error) => {
                localStorage.clear();
                if (error.response.status === 534) {
                    // setLoading(false);
                    // setIsLogoutModal(true);
                    return navigate(mindupAdminMobilePaths.login, { replace: true });
                }
                console.log(error, 'axiosInterceptResponseError');
                // setLoading(false);
                return Promise.reject(error);
            }
        );
    }, []);

    return (
        <>
            <GlobalStyles />
            <AppLayout>
                <Loading loading={loading} />
                <Suspense fallback={<Loading loading={loading} />}>
                    <InnerLayout>
                        <Outlet />
                    </InnerLayout>
                </Suspense>
                {onSnackbar === 'true' && <SnackBar visible={visible} message={message} type={type} onClose={hideSnackBar} duration={4000} buttonMessage={buttonMessage} onClick={onClick} />}
            </AppLayout>
        </>
    );
}

const AppLayout = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 100vh;
    height: auto;
    background-color: ${BackgroundColor.color_background_neutral};
`;

const InnerLayout = styled.div.attrs({
    className: 'mindup-layout',
})`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-width: 360px;
    max-width: 576px;
    min-height: 100vh;
    height: auto;
    background-color: white;
`;
